export const extendFulltextSearch = (params, concat = false) => {
    // TODO
    // replace ++ with + in loop
    // replace -- with - in loop
    /*while(params.keyword.indexOf('++') !== -1) {
        params.keyword = params.keyword.replace('++', '+');
    }*/
	let test = params.keyword.trim();
    //console.log(test);
	const quotes = test.matchAll(/"|\+"|\-"/g);
	const indexes = [];
	const quoteStrings = [];
    
    //console.log(quotes);
	
	for (const match of quotes) {
        //console.log(match.index);
		indexes.push(match.index);
	}
	
	//console.log(indexes);
	
	while(indexes.length) {
		let start = indexes.shift();
		let end = indexes.shift();
		
		if(Number.isInteger(start) && Number.isInteger(end)) {
			quoteStrings.push(test.slice(start, end+1));
		}
	}
	
	//console.log(quoteStrings);

	quoteStrings.forEach(str => {
		test = test.replace(str, "");
	});
	
	test = test.trim();
    
    //console.log(test);

    let keywords = test.split(' ');
    if (keywords.length > 1) {
        //let first = "";
        //console.log(keywords)
        keywords.forEach((keyword, index) => {
            if (keyword.length) {
                keywords[index] = getKeyword2(keyword, concat);
                /*first = keyword.charAt(0);
                if (first !== '+' && first !== '-') {
                    keywords[index] = concatKeyword(keyword, '+');
                } else if (first === '+') {
                    keywords[index] = concatKeyword(keyword.substring(1), '+');
                } else if (first === '-') {
                    keywords[index] = concatKeyword(keyword.substring(1), '-');
                }*/
            }
        });
    } else if (keywords.length/* && hasSpecialChar(keywords[0])*/) {
        keywords[0] = getKeyword(keywords[0], false);//'"' + keywords[0] + '"';
    }
    
    // correct quote strings if operator not set and concat==true -> set + operator
    if(concat) {
        quoteStrings.forEach((str, index) => {
            //console.log(str.indexOf("\""));
            if(str.indexOf("\"") === 0) {
                quoteStrings[index] = "+" + str;
            }
        });
    }
	
	keywords = keywords.concat(quoteStrings);
    
    // remove empty strings and empty quote strings
    keywords = keywords.filter(word => {
        return word !== "" && word !== '""' && word !== '+""' && word !== '-""';
    });

    return keywords.join(' ').trim();
}

/*
const concatKeyword = (keyword, operator) => {
    if (hasSpecialChar(keyword)) {
        return operator + '"' + keyword + '"';
    }
    return operator + keyword;
}
*/

const hasSpecialChar = (str) => {
    return str.match(/\W/) !== null;
}

const maskKeyword = (word) => {
    // remove single quotes
    const cleaned = word.replaceAll('"', '');
    if (cleaned.match(/\W/)) {
        return '"' + cleaned + '"';
        //return '"' + word + '"';
    }
    return cleaned;
}

// build array [ operator, word, star ]
// 
const getKeyword = (word, concat = true) => {
    let test = word;
    const keyword = concat ? ["+", test, ""] : ["", test, ""];
    const operator = test.match(/^\+|-/);
    const star = test.match(/\*$/);

    // set +/- operator and extract substring
    if (operator) {
        test = test.slice(1);

        if (concat) {
            keyword[0] = operator[0];
        } else {
            // set - operator if only one term set
            if (operator[0] === "-") {
                keyword[0] = operator[0];
            }
        }
    }

    // set star operator and extract substring
    if (star) {
        test = test.slice(0, -1);
        keyword[2] = "*";
    }

    if (!test.length) {
        return "";
    }

    keyword[1] = maskKeyword(test);

    return keyword.join('');
}

const getKeyword2 = (word, concat = false) => {
    let test = word;
    const keyword = concat ? ["+", test, ""] : ["", test, ""];
    const operator = test.match(/^\+|-/);
    const star = test.match(/\*$/);

    // set +/- operator and extract substring
    if (operator) {
        test = test.slice(1);

        if (concat) {
            keyword[0] = operator[0];
        } else {
            // set - operator if only one term set
            if (operator[0] === "-") {
                keyword[0] = operator[0];
            }
        }
    }

    // set star operator and extract substring
    if (star) {
        test = test.slice(0, -1);
        keyword[2] = "*";
    }

    if (!test.length) {
        return "";
    }

    keyword[1] = maskKeyword(test);

    return keyword.join('');
}

export const searchFullText = (params) => {
    if (params && params.keyword) {
        params.keyword = extendFulltextSearch(params);
    }
    
    window.flow.getClipsByFulltext(params.keyword).then(res => {
        
    });
}
